// @flow strict
import React, { useMemo } from "react";

function ServiceListFiltered({
  initialList,
  filters,
  onFilterChange,
  onResetFilters,
}) {
  // Extraire les options uniques pour les filtres
  const filterOptions = useMemo(() => {
    const categories = new Set();
    const prices = [];
    const durations = [];

    for (const item of Array.isArray(initialList) ? initialList : []) {
      const name = item?.category?.name;
      if (name) categories.add(name);

      const price = Number(item?.price);
      if (!isNaN(price)) prices.push(price);

      const duration = Number(item?.durationMinutes);
      if (!isNaN(duration)) durations.push(duration);
    }

    return {
      categories: Array.from(categories),
      minPrice: prices.length > 0 ? Math.min(...prices) : 0,
      maxPrice: prices.length > 0 ? Math.max(...prices) : 100,
      minDuration: durations.length > 0 ? Math.min(...durations) : 0,
      maxDuration: durations.length > 0 ? Math.max(...durations) : 120,
    };
  }, [initialList]);

  // Gérer les changements de case à cocher
  const handleCheckboxChange = (filterType, value) => {
    const currentValues = filters[filterType];
    const newValues = currentValues.includes(value)
      ? currentValues.filter((v) => v !== value)
      : [...currentValues, value];

    onFilterChange({
      ...filters,
      [filterType]: newValues,
    });
  };

  // Gérer les changements des champs de prix et durée
  const handleInputChange = (type, value) => {
    const numValue = value === "" ? null : Number(value);
    onFilterChange({
      ...filters,
      [type]: numValue,
    });
  };

  const hasActiveFilters =
    filters.category.length !== 0 ||
    filters.minDuration !== null ||
    filters.maxDuration !== null ||
    filters.minPrice !== null ||
    filters.maxPrice !== null;

  return (
    <div className="bg-white py-1">
      <div className="flex items-center justify-between pl-6 pr-1">
        <h2 className="font-poppins font-semibold text-[18px] text-title mb-6 hidden lg:flex">
          Filtres
        </h2>
        {hasActiveFilters && (
          <button
            onClick={onResetFilters}
            className="mb-4 px-4 py-2 bg-primary text-white hover:bg-primary/90 font-nunito font-semibold text-[14px]"
          >
            Réinitialiser
          </button>
        )}
      </div>

      <div className="px-6 space-y-6">
        {/* Filtre Catégorie */}
        <div className="border-b border-secondary-50">
          <h3 className="font-poppins font-semibold text-[18px] mb-3 text-title">
            Catégorie
          </h3>

          <div className="space-y-2">
            {filterOptions.categories.map((category) => (
              <label key={category} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={filters.category.includes(category)}
                  onChange={() => handleCheckboxChange("category", category)}
                  className="text-secondary-50 focus:ring-secondary-100"
                />
                <span className="font-nunito text-[14px] text-text">{category}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Filtre Prix */}
        <div className="border-b border-secondary-50 pb-2">
          <h3 className="font-poppins font-semibold text-[18px] mb-3 text-title">
            Prix
          </h3>
          <div className="flex space-x-4">
            <div>
              <label className="block font-poppins font-medium text-[15px] text-subtitle mb-1">
                Min
              </label>
              <input
                type="number"
                value={filters.minPrice || ""}
                onChange={(e) => handleInputChange("minPrice", e.target.value)}
                placeholder={filterOptions.minPrice.toString()}
                min={filterOptions.minPrice}
                max={filterOptions.maxPrice}
                className="w-full p-2 border font-nunito text-[14px] text-text border-gray-100 focus:ring-gray-300 focus:border-gray-300"
              />
            </div>
            <div>
              <label className="block font-poppins font-medium text-[15px] text-subtitle mb-1">
                Max
              </label>
              <input
                type="number"
                value={filters.maxPrice || ""}
                onChange={(e) => handleInputChange("maxPrice", e.target.value)}
                placeholder={filterOptions.maxPrice.toString()}
                min={filterOptions.minPrice}
                max={filterOptions.maxPrice}
                className="w-full p-2 border font-nunito text-[14px] text-text border-gray-100 focus:ring-gray-300 focus:border-gray-300"
              />
            </div>
          </div>
        </div>

        {/* Filtre Durée */}
        {/* <div className=" pb-2">
          <h3 className="font-poppins font-semibold text-[18px] mb-3 text-title">
            Durée (en minutes)
          </h3>
          <div className="flex space-x-4">
            <div>
              <label className="block font-poppins font-medium text-[15px] text-subtitle mb-1">
                Min
              </label>
              <input
                type="number"
                value={filters.minDuration || ""}
                onChange={(e) =>
                  handleInputChange("minDuration", e.target.value)
                }
                placeholder={filterOptions.minDuration.toString()}
                min={filterOptions.minDuration}
                max={filterOptions.maxDuration}
                className="w-full p-2 border font-nunito text-[14px] text-text border-gray-100 focus:ring-gray-300 focus:border-gray-300"
              />
            </div>
            <div>
              <label className="block font-poppins font-medium text-[15px] text-subtitle mb-1">
                Max
              </label>
              <input
                type="number"
                value={filters.maxDuration || ""}
                onChange={(e) =>
                  handleInputChange("maxDuration", e.target.value)
                }
                placeholder={filterOptions.maxDuration.toString()}
                min={filterOptions.minDuration}
                max={filterOptions.maxDuration}
                className="w-full p-2 border font-nunito text-[14px] text-text border-gray-100 focus:ring-gray-300 focus:border-gray-300"
              />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default ServiceListFiltered;